/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    'configuration': true,
    'searchList': {
        'searchTxt': [
            {
                'name': '仓库',
                'value': 'whName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'whCode', 'value': '仓库编码' }
                ],
                'tableConfig': [
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'cdwhName', 'value': '仓库名称' }
                ],
                'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                'cbParams': [
                    'whCode', 'cdwhName#whName'
                ],
                'type': 'advance',
                'span': 4
            },
            {
                'name': '订单类型',
                'value': 'orderType',
                'unfold': true,
                'type': 'select',
                'span': 4,
                'optionNum': 'ORDER_TYPE',
                'options': []
            },
            {
                'name': '状态',
                'value': 'enableFlag',
                'unfold': true,
                'type': 'select',
                'span': 4,
                'options': [
                    {
                        'label': '启用',
                        'value': 1
                    },
                    {
                        'label': '停用',
                        'value': 0
                    }
                ]
            }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table': {
        'clickModify': true,
        'selectBtn': true,
        'leftWidth': 100,
        'leftOperation': true,
        // 'customBtn': true,
        'height': 400,
        // 'btnDisplayCredentials': ['enableFlag'],
        'columns': [
            {
                'label': '客户时效编码',
                'prop': 'customerAgingCode',
                'require': true,
                'mustFill': true,
                'width': 170,
                'sort': true
            },
            {
                'label': '客户',
                'prop': 'customerName',
                'require': true,
                'mustFill': true,
                'width': 120,
                'sort': true
            },
            {
                'label': '客户时效名称',
                'prop': 'customerAgingName',
                'require': true,
                'mustFill': true,
                'width': 120,
                'sort': true
            },
            {
                'label': '仓库',
                'prop': 'whName',
                'require': true,
                'width': 120,
                'advanceConfig': [
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'whCode', 'value': '仓库编码' }
                ],
                'tableConfig': [
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'cdwhName', 'value': '仓库名称' }
                ],
                'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                'cbParams': [
                    'whCode', 'cdwhName#whName'
                ],
                'type': 'advance',
                'sort': true
            },
            {
                'label': '订单类型',
                'prop': 'orderType',
                'require': true,
                'width': 100,
                'type': 'select',
                'optionNum': 'ORDER_TYPE',
                'options': [],
                'sort': true
            },
            {
                'label': '是否中转出库',
                'prop': 'taskType',
                'require': true,
                'width': 130,
                'type': 'select',
                'optionNum': 'TASK_TYPE',
                'options': [],
                'sort': true
            },
            {
                'label': '配送方式',
                'prop': 'deliveryType',
                'require': true,
                'width': 100,
                'type': 'select',
                'optionNum': 'DELIVERY_TYPE',
                'options': [],
                'sort': true
            },
            {
                'label': '分拨仓',
                'prop': 'distributionWhName',
                'value': 'distributionWhName',
                'require': true,
                'width': 120,
                'advanceConfig': [
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'whCode', 'value': '仓库编码' }
                ],
                'tableConfig': [
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'cdwhName', 'value': '仓库名称' }
                ],
                'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                'cbParams': [
                    'whCode', 'cdwhName#distributionWhName'
                ],
                'type': 'advance',
                'sort': true
            },
            {
                'label': '业务模式',
                'prop': 'businessMode',
                'value': 'businessMode',
                'require': true,
                'width': 100,
                'type': 'select',
                'optionNum': 'BUSINESS_MODE',
                'options': [],
                'sort': true
            },
            {
                'label': '发货仓库',
                'prop': 'sendWhName',
                'value': 'sendWhName',
                'require': true,
                'width': 120,
                'advanceConfig': [
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'whCode', 'value': '仓库编码' }
                ],
                'tableConfig': [
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'cdwhName', 'value': '仓库名称' }
                ],
                'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                'cbParams': [
                    'whCode#sendWhCode', 'cdwhName#sendWhName'
                ],
                'type': 'advance',
                'sort': true
            },
            {
                'label': '发货地',
                'prop': 'sendTown',
                'require': true,
                'mustFill': true,
                'width': 160,
                'sort': true
            },
            {
                'label': '收货地',
                'prop': 'receiveTown',
                'require': true,
                'mustFill': true,
                'width': 160,
                'sort': true
            },
            {
                'label': '时效产品',
                'prop': 'agingProduct',
                'require': true,
                'mustFill': true,
                'width': 120,
                'sort': true
            },
            {
                'label': '状态',
                'prop': 'enableFlag',
                'require': true,
                'mustFill': true,
                'type': 'select',
                'options': [
                    {
                        'label': '启用',
                        'value': 1
                    },
                    {
                        'label': '停用',
                        'value': 0
                    }
                ],
                'sort': true
            },
            {
                'label': '截单时间（始~讫）',
                'prop': 'orderTimes',
                'width': 190,
                'sort': true
            },
            {
                'label': '计算起点',
                'prop': 'begainStatusName',
                'width': 90,
                'sort': true
            },
            {
                'label': '时效类型',
                'prop': 'customerAgingType',
                'value': 'customerAgingType',
                'require': true,
                'width': 100,
                'type': 'select',
                'optionNum': 'CUSTOMER_AGING_TYPE',
                'options': [],
                'sort': true
            },
            {
                'label': '范围-从（不包括）',
                'prop': 'rangeFrom',
                // 'require': true,
                // 'mustFill': true,
                'sort': true,
                'width': 150
            },
            {
                'label': '范围-至（包括）',
                'prop': 'rangeTo',
                // 'require': true,
                // 'mustFill': true,
                'sort': true,
                'width': 150
            },
            {
                'label': '创建人',
                'prop': 'createUserCode',
                'sort': true,
                'width': 90
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'sort': true,
                'width': 150
            },
            {
                'label': '修改人',
                'prop': 'updateUserCode',
                'sort': true,
                'width': 90
            },
            {
                'label': '修改时间',
                'prop': 'updateTime',
                'sort': true,
                'width': 150
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '复制',
                'size': 'mini',
                'event': 'copy'
            },
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit'
            }
        ],
        'ImportConfig': {
            'action': `${process.env.VUE_APP_API_URL || ''}/api-otp/customerAgingConfig/import`,
            'multiple': false,
            'accept': 'xlsx/text',
            'showFileList': true,
            'fileType': '只能上传Excel文件，且不超过500kb',
            'manualUpload': true
        },
        'ImportContent': [
            {
                'fileName': '客户时效.xlsx',
                'fileSize': '10.5KB',
                'downLoadInfo': {
                    'url': 'https://anapi.annto.com/api-file/ossDown/221E3F05DE3A467DA9B2F79682D750E9/lcloud/%E5%AE%A2%E6%88%B7%E6%97%B6%E6%95%88_1577417443854.xlsx'
                }
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [
            10,
            20,
            30,
            50
        ]
    },
    'dialog': {
        'type': 'normal',
        'title': '时效编码',
        'gutter': 10,
        'width': '1280px',
        hideTable: true,
        'btnList': [{
            'type': 'negative',
            'text': '取消'
        }, {
            'type': 'sure',
            'text': '确定'
        }],
        'dialogForm': {
            'labelWidth': 8,
            'inputWidth': 16,
            'labelEnd': true,
            'inline': true,
            'btnSpan': 3,
            'inputList': [
                {
                    'label': '客户时效名称',
                    'prop': '',
                    'value': 'customerAgingName',
                    'mustFill': true,
                    'span': 6,
                    'type': 'text'
                },
                {
                    'label': '客户时效编码',
                    'value': 'customerAgingCode',
                    'disabled': true,
                    'readOnly': true,
                    'span': 6,
                    'type': 'text'
                },
                {
                    'label': '业务模式',
                    'prop': '',
                    'value': 'businessMode',
                    'span': 6,
                    'type': 'dictionary',
                    'optionNum': 'BUSINESS_MODE',
                    'mustFill': true
                },
                {
                    'label': '订单类型',
                    'value': 'orderType',
                    'relyOnVlaue': [
                        { 'field': 'deliveryType', 'value': 'YS', 'targetValue': 'ZT', 'setValue': '' }
                    ],
                    'span': 6,
                    'type': 'dictionary',
                    'mustFillOpration': true,
                    'mustFill': true,
                    'optionNum': 'ORDER_TYPE'
                },
                {
                    'label': '配送方式',
                    'value': 'deliveryType',
                    'relyOnVlaue': [
                        { 'field': 'orderType', 'value': 'ZT', 'targetValue': 'YS', 'setValue': '' }
                    ],
                    'span': 6,
                    'type': 'dictionary',
                    'mustFill': true,
                    'optionNum': 'DELIVERY_TYPE'
                },
                {
                    'label': '平台',
                    'name': '平台',
                    'advanceLabel': '平台',
                    'prop': 'siteName',
                    'value': 'siteName',
                    'span': 6,
                    'mustFill': true,
                    // 'readOnly': true,
                    'width': 200,
                    'advanceConfig': [
                        { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                        { 'prop': 'escoCompanyNo', 'value': '平台编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'escoCompanyNo', 'value': '平台编码' },
                        { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                        { 'prop': 'branchCompanyNo', 'value': '分公司编码' },
                        { 'prop': 'branchCompanyName', 'value': '分公司名称' }
                    ],
                    'advanceUrl': 'searchPlatform',
                    'type': 'advance',
                    'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
                },
                {
                    'label': '仓库',
                    'name': '仓库',
                    'mustFill': false,
                    'advanceLabel': '仓库',
                    'mustFillRelyOn': { 'orderType': '!=YS' },
                    'prop': 'whName',
                    'value': 'whName',
                    // 'readOnly': true,
                    'span': 6,
                    'type': 'advance',
                    'advanceCascade': 'siteCode',
                    'advanceConfig': [
                        { 'prop': 'cdwhName', 'value': '仓库名称' },
                        { 'prop': 'whCode', 'value': '仓库编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'whCode', 'value': '仓库编码' },
                        { 'prop': 'cdwhName', 'value': '仓库名称' }
                    ],
                    'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                    'cbParams': [
                        'whCode#whCode', 'cdwhName#whName'
                    ]
                },
                {
                    'label': '客户',
                    'name': '客户',
                    'prop': 'customerName',
                    'value': 'customerName',
                    'span': 6,
                    'type': 'advance',
                    'advanceLabel': '客户',
                    'advanceConfig': [
                        { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                        { 'prop': 'pmCode', 'value': '客户编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'pmCode', 'value': '客户编码' },
                        { 'prop': 'ebcuNameCn', 'value': '客户名称' }
                    ],
                    'advanceUrl': 'ebCustomer/searchByEbCustomer',
                    'cbParams': ['pmCode#customerCode', 'ebcuNameCn#customerName']
                },
                {
                    'label': '发货地',
                    'value': 'send',
                    'minLayers': 3,
                    'span': 12,
                    labelWidth: 4,
                    inputWidth: 20,
                    'mustFill': false,
                    'mustFillRelyOn': { 'orderType': 'RI|DPRI|YS', logic: '&&', taskType: '!=RDO' },
                    'disabledRelyOn': { 'deliveryType': 'ZT' },
                    'valueDependentOnDisabled': { 'val': true, 'setValue': [] },
                    'type': 'addressSelect',
                    'config': {
                        'checkStrictly': true
                    }
                },
                {
                    'label': '收货地',
                    'value': 'receive',
                    'mustFillRelyOn': { 'orderType': 'PO|AO|DP|YS', logic: '&&', taskType: '!=RDO' },
                    'disabledRelyOn': { 'deliveryType': 'ZT' },
                    'minLayers': 3,
                    'mustFill': true,
                    'valueDependentOnDisabled': { 'val': true, 'setValue': [] },
                    'span': 12,
                    labelWidth: 4,
                    inputWidth: 20,
                    'type': 'addressSelect',
                    'config': {
                        'checkStrictly': true
                    }
                },
                {
                    'label': '时效类型',
                    'name': '时效类型',
                    'value': 'customerAgingType',
                    'mustFill': true,
                    'span': 6,
                    'type': 'dictionary',
                    'optionNum': 'CUSTOMER_AGING_TYPE'
                },
                {
                    'label': '范围（从-不包括）',
                    'prop': '',
                    'value': 'rangeFrom',
                    'mustFill': false,
                    'span': 6,
                    'type': 'text'
                },
                {
                    'label': '范围（至-包括）',
                    'prop': '',
                    'value': 'rangeTo',
                    'mustFill': false,
                    'span': 6,
                    'type': 'text'
                },
                {
                    'label': '定日达周期',
                    'prop': '',
                    'value': 'agingCircle',
                    'span': 6,
                    'type': 'text'
                },
                {
                    'label': '时效产品',
                    'prop': '',
                    'value': 'agingProduct',
                    'mustFill': true,
                    'span': 6,
                    'type': 'dictionary',
                    'optionNum': '',
                    'options': []
                },
                {
                    'label': '截单开始时间',
                    'prop': '',
                    'value': 'orderStartTime',
                    'mustFillRelyOn': { 'orderType': 'YS|PO|AO|RO|TFO|ADO|TO|DO|RDO|TF', 'deliveryType': '!=ZT' },
                    'mustFill': false,
                    'span': 6,
                    'type': 'select',
                    'options': []
                },
                {
                    'label': '截单结束时间',
                    'prop': '',
                    'value': 'orderEndTime',
                    'mustFillRelyOn': { 'orderType': 'YS|PO|AO|RO|TFO|ADO|TO|DO|RDO|TF', 'deliveryType': '!=ZT' },
                    'mustFill': false,
                    'span': 6,
                    'type': 'select',
                    'options': []
                },
                {
                    'label': '时效起点',
                    'prop': '',
                    'value': 'agingStartTime',
                    'mustFillRelyOn': { 'orderType': 'YS|PO|AO|RO|TFO|ADO|TO|DO|RDO|TF', 'deliveryType': '!=ZT' },
                    'mustFill': false,
                    'span': 6,
                    'type': 'select',
                    'options': []
                },
                {
                    'label': '分拨仓',
                    'name': '分拨仓',
                    'prop': 'distributionWhName',
                    'value': 'distributionWhName',
                    'advanceLabel': '分拨仓',
                    // 'readOnly': true,
                    'span': 6,
                    'type': 'advance',
                    'advanceConfig': [
                        { 'prop': 'transferCenterName', 'value': '仓库名称' },
                        { 'prop': 'transferCenterCode', 'value': '仓库编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'transferCenterCode', 'value': '仓库编码' },
                        { 'prop': 'transferCenterName', 'value': '仓库名称' }
                    ],
                    'prefix': '/api-dc/',
                    'advanceUrl': 'transfer/center/config/page?enableFlag=1&enableTenant=0',
                    'cbParams': [
                        'transferCenterCode#distributionWhCode', 'transferCenterName#distributionWhName'
                    ]
                },
                {
                    'label': '发货仓库',
                    'name': '发货仓库',
                    'prop': 'sendWhName',
                    'value': 'sendWhName',
                    'advanceLabel': '发货仓库',
                    'span': 5,
                    'type': 'advance',
                    'disabledRelyOn': { taskType: '!=RDO' },
                    'valueDependentOnDisabled': { 'val': true, 'setValue': null }, // 只删除了name 注意代码里同步处理删除code
                    'advanceConfig': [
                        { 'prop': 'cdwhName', 'value': '仓库名称' },
                        { 'prop': 'whCode', 'value': '仓库编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'whCode', 'value': '仓库编码' },
                        { 'prop': 'cdwhName', 'value': '仓库名称' }
                    ],
                    'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                    'cbParams': [
                        'whCode#sendWhCode', 'cdwhName#sendWhName'
                    ]
                },
                {
                    'label': '',
                    'prop': '',
                    labelWidth: 1,
                    inputWidth: 24,
                    'value': 'taskType',
                    'disabledRelyOn': { 'orderType': 'AADI|ADI|ADO|AI|AO|DO|DP|JDPI|PI|PO|RDO|RO|RRI|TF|TFI|TFO|TI|TO|YS' },
                    'valueDependentOnDisabled': { 'val': true, 'setValue': '' },
                    'span': 1,
                    'type': 'checkbox'
                },
                // {
                //     'label': '是否中转出库',
                //     'prop': '',
                //     'value': 'taskType',
                //     'disabledRelyOn': { 'orderType': 'AADI|ADI|ADO|AI|AO|DO|DP|JDPI|PI|PO|RDO|RO|RRI|TF|TFI|TFO|TI|TO|YS' },
                //     'valueDependentOnDisabled': { 'val': true, 'setValue': '' },
                //     'span': 6,
                //     'type': 'dictionary',
                //     options: [{ 'value': 'RDO', 'label': '是' }, { 'value': '', 'label': '否' }]
                // },
                {
                    'label': '生效时间',
                    'prop': '',
                    'value': 'validTime',
                    'mustFill': true,
                    'span': 6,
                    'type': 'datePicker'
                },
                {
                    'label': '失效时间',
                    'prop': '',
                    'value': 'invalidTime',
                    'mustFill': true,
                    'span': 6,
                    pickerOptions: {
                        disabledDate(time) {
                            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                        }
                    },
                    'type': 'datePicker'
                }
                // {
                //     'label': '上游平台',
                //     'name': '上游平台',
                //     'value': 'sourceSystem',
                //     'span': 6,
                //     'type': 'dictionary',
                //     'optionNum': 'SOURCE_SYSTEM'
                // }
            ]
        },
        // 'dialogTable': {
        //     'width': '',
        //     'border': true,
        //     'isPagination': true,
        //     'btnActive': true,
        //     'columns': [
        //         {
        //             'label': '订单状态',
        //             'prop': 'status',
        //             'type': 'select',
        //             'mustFill': true,
        //             'optionNum': 'AGING_ORDER_STATUS',
        //             'options': []
        //         },
        //         {
        //             'label': '时效要求',
        //             'mustFill': true,
        //             'prop': 'agingHour'
        //         },
        //         {
        //             'label': '预警',
        //             'prop': 'warnHour'
        //         },
        //         {
        //             'label': '计算起点',
        //             'prop': 'begainStatus',
        //             'type': 'select',
        //             'optionNum': 'AGING_ORDER_STATUS',
        //             'options': []
        //         }
        //     ],
        //     'action': {
        //         'fixed': 'right',
        //         'width': '80',
        //         'list': [
        //             {
        //                 'text': '删除',
        //                 'event': 'delete'
        //             },
        //             {
        //                 'text': '编辑',
        //                 'event': 'edit'
        //             }
        //         ]
        //     }
        // },
        'siteWhTable': {
            'width': '',
            'border': true,
            'isPagination': false,
            'btnActive': true,
            'columns': [
                {
                    'label': '站点序号',
                    'prop': 'sortNo',
                    type: 'text',
                    width: '80'
                },
                {
                    'label': '平台名称',
                    value: 'siteName',
                    'mustFill': true,
                    'prop': 'siteName',
                    'advanceConfig': [
                        { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                        { 'prop': 'escoCompanyNo', 'value': '平台编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'escoCompanyNo', 'value': '平台编码' },
                        { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                        { 'prop': 'branchCompanyNo', 'value': '分公司编码' },
                        { 'prop': 'branchCompanyName', 'value': '分公司名称' }
                    ],
                    'advanceUrl': '/searchPlatform',
                    'type': 'advance',
                    width: '120',
                    noShowTooltip: true,
                    'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
                },
                {
                    'type': 'agingSitAdvance',
                    'prop': 'whName',
                    'label': '仓库名称',
                    params: [
                        {
                            'label': '仓库名称',
                            value: 'whName',
                            'prop': 'whName',
                            'mustFill': true,
                            'advanceConfig': [
                                { 'prop': 'cdwhName', 'value': '仓库名称' },
                                { 'prop': 'whCode', 'value': '仓库编码' }
                            ],
                            'tableConfig': [
                                { 'prop': 'whCode', 'value': '仓库编码' },
                                { 'prop': 'cdwhName', 'value': '仓库名称' }
                            ],
                            'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                            'cbParams': [
                                'whCode#whCode', 'cdwhName#whName'
                            ],
                            'type': 'advance',
                            width: '120',
                            noShowTooltip: true,
                            'advanceCascade': 'siteCode,siteName'
                        },
                        {
                            'label': '仓库名称',
                            value: 'whName',
                            'prop': 'whName',
                            'mustFill': true,
                            'advanceConfig': [
                                { 'prop': 'transferCenterName', 'value': '仓库名称' },
                                { 'prop': 'transferCenterCode', 'value': '仓库编码' }
                            ],
                            'tableConfig': [
                                { 'prop': 'transferCenterCode', 'value': '仓库编码' },
                                { 'prop': 'transferCenterName', 'value': '仓库名称' },
                                { 'prop': 'siteCode', 'value': '平台编码' },
                                { 'prop': 'siteName', 'value': '平台名称' }
                            ],
                            'prefix': '/api-dc/',
                            'advanceUrl': 'transfer/center/config/page?enableFlag=1&enableTenant=0',
                            'cbParams': [
                                'transferCenterCode#whCode', 'transferCenterName#whName'
                            ],
                            width: '120',
                            noShowTooltip: true
                            // 'advanceCascade': 'siteCode,siteName'
                        }
                    ]
                },
                {
                    'label': '站点属性',
                    'prop': 'stationType',
                    'type': 'select',
                    'mustFill': true,
                    unclearable: true,
                    disabled: true,
                    'options': [
                        { 'value': 'PROPRIETARY', 'label': '自营' },
                        { 'value': 'EXTERNAL', 'label': '外部' }
                    ]
                },
                {
                    'label': '是否快运',
                    'prop': 'transferFlag',
                    'type': 'select',
                    'mustFill': true,
                    // unclearable: true,
                    'options': [
                        { 'value': '1', 'label': '是' },
                        { 'value': '0', 'label': '否' }
                    ]
                }
            ],
            'action': {
                'fixed': 'right',
                'width': '100',
                'list': [
                    {
                        'text': '删除',
                        'event': 'delete'
                    },
                    {
                        'text': '编辑',
                        'event': 'edit'
                    }
                ]
            }
        },
        'agingConfigTable1': {
            'width': '',
            'border': true,
            'isPagination': false,
            'btnActive': true,
            'columns': [
                {
                    'label': '订单状态',
                    'prop': 'status',
                    'type': 'select',
                    'mustFill': true,
                    noShowTooltip: true,
                    'optionNum': 'FIRST_STATION_AGING',
                    'options': []
                },
                {
                    'label': '时效要求',
                    'mustFill': true,
                    noShowTooltip: true,
                    'type': 'agingTime',
                    'prop': 'agingReqTime'
                },
                {
                    'label': '预警',
                    noShowTooltip: true,
                    'prop': 'warnHour'
                },
                {
                    'label': '计算起点',
                    'prop': 'begainStatus',
                    'type': 'select',
                    noShowTooltip: true,
                    'optionNum': 'FIRST_STATION_AGING',
                    'options': []
                },
                {
                    'label': '历时（小时）',
                    noShowTooltip: true,
                    'prop': 'agingHour'
                }
            ],
            'action': {
                'fixed': 'right',
                'width': '100',
                'list': [
                    {
                        'text': '删除',
                        'event': 'delete'
                    },
                    {
                        'text': '编辑',
                        'event': 'edit'
                    }
                ]
            }
        },
        'agingConfigTable': {
            'width': '',
            'border': true,
            'isPagination': false,
            'btnActive': true,
            'columns': [
                {
                    'label': '订单状态',
                    'prop': 'status',
                    'type': 'select',
                    'mustFill': true,
                    'optionNum': 'NEXT_STATION_AGING',
                    noShowTooltip: true,
                    'options': []
                },
                {
                    'label': '时效要求',
                    'mustFill': true,
                    'type': 'agingTime',
                    noShowTooltip: true,
                    'prop': 'agingReqTime'
                },
                {
                    'label': '预警',
                    noShowTooltip: true,
                    'prop': 'warnHour'
                },
                {
                    'label': '计算起点',
                    'prop': 'begainStatus',
                    'type': 'select',
                    noShowTooltip: true,
                    'optionNum': 'NEXT_STATION_AGING',
                    'options': []
                },
                {
                    'label': '历时（小时）',
                    noShowTooltip: true,
                    'prop': 'agingHour'
                }
            ],
            'action': {
                'fixed': 'right',
                'width': '100',
                'list': [
                    {
                        'text': '删除',
                        'event': 'delete'
                    },
                    {
                        'text': '编辑',
                        'event': 'edit'
                    }
                ]
            }
        },
        'agingConfigTableDO': {
            'width': '',
            'border': true,
            'isPagination': false,
            'btnActive': true,
            'columns': [
                {
                    'label': '订单状态',
                    'prop': 'status',
                    'type': 'select',
                    'mustFill': true,
                    noShowTooltip: true,
                    'optionNum': 'DO_FIRST_STATION_AGING',
                    'options': []
                },
                {
                    'label': '时效要求',
                    'mustFill': true,
                    noShowTooltip: true,
                    'type': 'agingTime',
                    'prop': 'agingReqTime'
                },
                {
                    'label': '预警',
                    noShowTooltip: true,
                    'prop': 'warnHour'
                },
                {
                    'label': '计算起点',
                    'prop': 'begainStatus',
                    'type': 'select',
                    noShowTooltip: true,
                    'optionNum': 'DO_FIRST_STATION_AGING',
                    'options': []
                },
                {
                    'label': '历时（小时）',
                    noShowTooltip: true,
                    'prop': 'agingHour'
                }
            ],
            'action': {
                'fixed': 'right',
                'width': '100',
                'list': [
                    {
                        'text': '删除',
                        'event': 'delete'
                    },
                    {
                        'text': '编辑',
                        'event': 'edit'
                    }
                ]
            }
        }
    },
    'searchTotalTitle': [
        {
            'name': '客户',
            'value': 'customerName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#customerCode', 'ebcuNameCn#customerName'],
            'advanceCode': 'advanceCode'
        },
        {
            'name': '客户时效名称',
            'value': 'customerAgingName',
            'type': 'input'
        },
        {
            'name': '客户时效编码',
            'value': 'customerAgingCode',
            'type': 'input'
        },
        {
            'name': '业务模式',
            'value': 'businessMode',
            'type': 'select',
            'optionNum': 'BUSINESS_MODE'
        },
        {
            'name': '配送方式',
            'value': 'deliveryType',
            'type': 'select',
            'optionNum': 'DELIVERY_TYPE'
        },
        {
            'name': '平台',
            'value': 'siteName',
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                { 'prop': 'branchCompanyNo', 'value': '分公司编码' },
                { 'prop': 'branchCompanyName', 'value': '分公司名称' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'branchCompanyNo', 'value': '分公司编码' },
                { 'prop': 'branchCompanyName', 'value': '分公司名称' }
            ],
            'advanceUrl': 'searchPlatform',
            'type': 'advance',
            'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
        },
        {
            'name': '分拨仓',
            'value': 'distributionWhName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'cdwhName', 'value': '仓库名称' },
                { 'prop': 'whCode', 'value': '仓库编码' }
            ],
            'tableConfig': [
                { 'prop': 'whCode', 'value': '仓库编码' },
                { 'prop': 'cdwhName', 'value': '仓库名称' }
            ],
            'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
            'cbParams': [
                'whCode#distributionWhCode', 'cdwhName#distributionWhName'
            ]
        },
        {
            'name': '定日达周期',
            'value': 'agingCircle',
            'type': 'input'
        },
        {
            'name': '时效产品',
            'value': 'agingProduct',
            'type': 'select',
            'optionNum': '',
            'options': []
        },
        {
            'name': '起始地',
            'value': 'sendTownCodes',
            'minLayers': 2,
            'type': 'addressSelect',
            'config': {
                'checkStrictly': true,
                'clearable': true
            }
        },
        {
            'name': '目的地',
            'value': 'receiveTownCodes',
            'minLayers': 2,
            'type': 'addressSelect',
            'config': {
                'checkStrictly': true,
                'clearable': true
            }
        },
        {
            'name': '上游平台',
            'value': 'sourceSystem',
            'type': 'select',
            'optionNum': 'SOURCE_SYSTEM'
        },
        {
            'name': '截单开始时间',
            'value': 'orderStartTime',
            'type': 'select',
            'options': []
        },
        {
            'name': '截单结束时间',
            'value': 'orderEndTime',
            'type': 'select',
            'options': []
        },
        {
            'name': '时效起点',
            'value': 'agingStartTime',
            'type': 'select',
            'options': []
        },
        {
            'name': '是否中转',
            'value': 'taskType',
            'type': 'select',
            options: [{ 'value': 'RDO', 'label': '是' }, { 'value': 'N', 'label': '否' }]
        }
    ]
};